import clsx from "clsx"
import { NpProductGridItem } from "src/components/home/NpProductGridItem"
import {
  npPageGap2ClassName,
  npPagePtClassName,
  npPagePxClassName,
  npSectionMtClassName,
} from "src/components/np-design/components/constants"
import { NpHeading } from "src/components/np-design/components/NpSubtitle"
import { ListProductData } from "src/data/product-list/types"

export type NpProductGridProps = {
  listId: string
  heading: string
  products: ListProductData[]
  standalone?: boolean
}

export const NpProductGrid = ({ listId, heading, products, standalone = true }: NpProductGridProps) => {
  return (
    <section
      id={listId}
      className={clsx(
        standalone ? npSectionMtClassName : npPagePtClassName,
        standalone && npPagePxClassName,
        "w-full max-w-full",
      )}
    >
      <div className={clsx(npPageGap2ClassName, "mx-auto flex w-300 max-w-full flex-col")}>
        <NpHeading as="h2">{heading}</NpHeading>

        <div
          className={clsx(
            npPageGap2ClassName,
            "mx-auto grid grid-cols-1 justify-center justify-items-center gap-x-10 md:grid-cols-2",
          )}
        >
          {products.map((product, index) => {
            return <NpProductGridItem key={index} listId={listId} product={product} />
          })}
        </div>
      </div>
    </section>
  )
}
